import React, { useState } from 'react';

export default function OtpInput({ onSubmit, onResend, loading, resending }) {
	const [code, setCode] = useState('');

	const handleSubmit = (e) => {
		e.preventDefault();
		if (code.trim()) {
			onSubmit(code.trim());
		}
	};

	return (
		<div className="otp-input">
			<h3>OTP Verification</h3>
			<p>Enter the verification code sent to the contact's mobile number.</p>
			<form onSubmit={handleSubmit}>
				<div className="input-group">
					<input
						type="text"
						value={code}
						onChange={(e) => setCode(e.target.value)}
						placeholder="Enter 6-digit code"
						maxLength={6}
						pattern="[0-9]*"
						required
						disabled={loading}
					/>
					<button type="submit" disabled={loading || !code.trim()}>
						{loading ? 'Verifying...' : 'Verify'}
					</button>
				</div>
			</form>
			<button
				onClick={onResend}
				disabled={resending}
				className="btn-link"
			>
				{resending ? 'Resending...' : 'Resend OTP'}
			</button>
		</div>
	);
}
